module.exports = __webpack_public_path__ + "assets/shopping_cart_dish_default-076651.svg";